var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgIcPlayOnTileSmall = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M7.3 6.357V17.46c0 1.446 1.581 2.336 2.817 1.585l8.636-5.247a1.854 1.854 0 0 0 .078-3.12l-8.636-5.855-.673.993.673-.993C8.964 3.988 7.3 4.87 7.3 6.357",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcPlayOnTileSmall);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };